
import React from 'react';

const ProcessorCollaboration = () => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-3">VIII. Collaboration with processors (cf. Art. 28 EU-GDPR)</h3>
      <p className="text-gray-600">
        Like other companies, we also use external service providers, both domestic and foreign, to handle our business operations (e.g. IT, logistics, telecommunications, sales and marketing). They act only on our instructions and have contractually committed to comply with data protection regulations in accordance with Art. 28 EU-GDPR.
      </p>
      <p className="text-gray-600">
        If your personal data is passed on by us to our partner companies or from our partner companies to us (e.g. for advertising purposes), this is done on the basis of existing processing agreements.
      </p>
    </div>
  );
};

export default ProcessorCollaboration;
